/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { ServiceProviderVoModel } from './service-provider-vo.model';
import { OfferVO } from './offer-vo.model';
import {TimeAvailabilityModel} from "./time-availability.model";
import {DelCustomerVO} from "./del-customer-vo.model";

export class OfferTemplateMetadataModel extends JSONable {

  offerRequestNumber: string | undefined = undefined;

  numberOfShipments: number | undefined = undefined;

  numberOfGroups: number | undefined = undefined;

  requestDate: string | undefined = undefined;

  deadline: string | undefined = undefined;

  serviceProviders: Array<ServiceProviderVoModel> | undefined = undefined;

  spOfferRequestUuid: string | undefined = undefined;

  contactPhone: string | undefined = undefined;

  customerVO: DelCustomerVO | undefined = undefined;

  minimumOfferTimeAvailability: TimeAvailabilityModel | undefined = undefined;

  // frontend only
  numberOfRoutingSolutions: number | undefined = undefined;
  progress: number | undefined = undefined;
  totalCost: number | undefined = undefined;

}
